import React from 'react'
import { Box, Card, Divider, ListItem, ListItemText, Skeleton } from '@mui/material'

const PaymentSummarySkeleton = () => (
  <Box flex={1} height="100%">
    <Card elevation={0} variant="outlined" sx={{ width: '100%' }}>
      <ListItem>
        <ListItemText primary={<Skeleton width={180} height={24} />} secondary={<Skeleton width={120} height={40} />} />
      </ListItem>
      <Divider />
      <ListItem>
        <ListItemText primary={<Skeleton width={140} height={20} />} secondary={<Skeleton width={100} height={20} />} />
      </ListItem>
      <ListItem>
        <Skeleton variant="rectangular" height={32} width={120} />
      </ListItem>
      <Divider />
      <Box p={2}>
        <Skeleton variant="rectangular" height={120} />
      </Box>
    </Card>
  </Box>
)

export default PaymentSummarySkeleton
